import HomeAssumptionsAvivaOwnLivePage from './HomeAssumptionsAvivaOwnLivePage';

export default HomeAssumptionsAvivaOwnLivePage;
